module.exports = __webpack_public_path__ + "media/images/logo/cq-ea157c3e98c61fd5213f86f6f83e7c6c.png";